import { Component, OnInit, Output, ViewChild } from '@angular/core';
import { MasterDataService } from '../../Services/MasterDataService';
import { BaseComponent } from '../../Library/BaseComponent';
import { ActivatedRoute, Router } from '@angular/router';
import { ShiftSetUp } from '../ShiftSetUp/ShiftSetUp';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'SectionLocation',
    templateUrl: './SectionLocation.html',
})

export class SectionLocation extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    ModalRef: NgbModalRef;
    SectionLocations: Array<any>;
    SectionId: number;
    DisableModalOpenEvent: boolean = false;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public modalService: NgbModal, public shiftSetUp: ShiftSetUp) {
        super(translate, toastr, route, router, masterService);        
    }
    ngOnInit(): void {
        this.SectionId = 0;
    }

    Open(sectionId: number): void {
        if (this.DisableModalOpenEvent) return;
        this.SectionId = sectionId;
        this.SectionLocations = this.shiftSetUp.ShiftResponseModel.SectionLocations.filter((row) => {
            return row.SectionId == sectionId;
        })
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            size: 'lg', 
            centered: true
        };
        this.ModalRef = this.modalService.open(this.content,ngbModalOptions);
        this.DisableModalOpenEvent = true;
        this.ModalRef.result.then((result) => {
        }, (reason) => {
            this.DisableModalOpenEvent = false;
        });
    }
    
    onKeyword(value: string): void {
        this.SectionLocations = this.shiftSetUp.ShiftResponseModel.SectionLocations.filter((row) => {
            if (value == null || value.trim() == "") {
                return true;
            }
            let data = row.LocationDescription.toUpperCase();
            value = value.toLocaleUpperCase();
            return (row.SectionId == this.SectionId && data.indexOf(value) >= 0);
        })
    }
}
